<template>
  <div class="superconductivity-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>B_internal = 0 | R = 0$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- External Magnetic Field Lines -->
          <g v-if="magnetVisible">
            <path v-for="y in 6" :key="'b'+y" :d="calcFieldLine(y*40 - 20)" fill="none" stroke="rgba(0, 210, 255, 0.2)" stroke-width="1.5" />
          </g>

          <!-- Superconductor Material -->
          <g transform="translate(160, 100)">
             <rect x="0" y="0" width="80" height="40" rx="4" :fill="isSuper ? '#00d2ff' : '#888'" opacity="0.6" stroke="#fff" />
             <text x="10" y="25" fill="#fff" font-size="10" font-weight="bold">{{ isSuper ? '超导体' : '常规导体' }}</text>
          </g>

          <!-- Floating Magnet -->
          <g v-if="magnetVisible" :transform="`translate(200, ${isSuper ? 60 : 100})`">
             <rect x="-20" y="-10" width="40" height="20" fill="#333" stroke="#888" />
             <rect x="-20" y="-10" width="20" height="20" fill="#ff4757" />
             <text x="0" y="5" text-anchor="middle" fill="#fff" font-size="8">磁铁</text>
          </g>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>温度 T / Critical T_c</label>
              <div class="value">{{ temp }} K</div>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row items-center">
             <label>调节温度 (临界点 ≈ 77 K)</label>
             <el-slider v-model="temp" :min="10" :max="200" size="mini"></el-slider>
          </div>
          <div class="row">
             <el-checkbox v-model="magnetVisible">施加外部磁场</el-checkbox>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>当物质进入超导态时，不仅电阻消失，还会将内部磁感线完全排出体外，使内部磁感应强度恒为零。这就是**迈斯纳效应**（Meissner Effect）。磁感线被排出产生的斥力可以抵消磁铁重力，实现**磁悬浮**。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SuperconductivityViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      temp: 150,
      magnetVisible: true
    }
  },
  computed: {
    isSuper() { return this.temp < 77; },
    calcFieldLine() {
       return (yBase) => {
          let xStart = 50;
          let xEnd = 350;
          let d = `M ${xStart} ${yBase} `; // eslint-disable-line no-unused-vars
          // Distort lines around the superconductor if in super state
          if (this.isSuper) {
             // Lines curve around the box (160, 100) to (240, 140)
             if (yBase > 60 && yBase < 180) {
               let midY = 120;
               let offset = yBase < midY ? -40 : 40;
               return `M ${xStart} ${yBase} Q 200 ${yBase + offset} ${xEnd} ${yBase}`;
             }
          }
          return `M ${xStart} ${yBase} L ${xEnd} ${yBase}`;
       }
    }
  }
}
</script>

<style scoped lang="scss">
.superconductivity-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
